/**
 * Voice editor — JS twin of reader.service.voice_sections on the BE.
 *
 * Authoring shape is four prose slots — tone, style, specialty,
 * boundaries — stored on Reader.voice_sections (JSON). The canonical
 * Reader.voice TextField that LLM reading prompts inject is composed
 * from the sections at save-time. The BE has the authoritative
 * compose_voice; this FE helper exists so the editor can:
 *   - hydrate from a persisted shape with missing/extra/garbage keys
 *   - render a live preview of the composed voice (so operators see
 *     what the LLM will actually receive)
 *
 * Keep the SECTION_KEYS, labels, and compose order in lockstep with
 * reader/service/voice_sections.py — they ARE the public contract.
 */

export const SECTION_KEYS = ['tone', 'style', 'specialty', 'boundaries']

export const SECTION_LABELS = {
  tone: 'Tone',
  style: 'Speaking style',
  specialty: 'Specialty',
  boundaries: 'Boundaries',
}

export function emptyVoiceSections() {
  return { tone: '', style: '', specialty: '', boundaries: '' }
}

export function coerceVoiceSections(raw) {
  const out = emptyVoiceSections()
  if (!raw || typeof raw !== 'object') return out
  for (const k of SECTION_KEYS) {
    const v = raw[k]
    out[k] = typeof v === 'string' ? v : ''
  }
  return out
}

export function composeVoice(sections) {
  const coerced = coerceVoiceSections(sections)
  const parts = []
  for (const k of SECTION_KEYS) {
    const text = (coerced[k] || '').trim()
    if (!text) continue
    parts.push(`${SECTION_LABELS[k]}:\n${text}`)
  }
  return parts.join('\n\n')
}
